










































































import MessageTypesFilter from "@/components/Settings/MessageTypes/MessageTypesFilter.vue";
import {ScrollButton} from "wings-ui-components";
import { Component } from "vue-property-decorator";
import { MessageTypeItem } from "@/store/settings/message_types/types";
import { Getter } from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({ components: { MessageTypesFilter, ScrollButton } })
export default class MessageTypes extends BaseItemsPage<MessageTypeItem> {

  @Getter("messageTypes") messageTypesResponse: any;

  private is_show_filter = false;
  currentSort = "name";
  currentSortOrder = "desc";
  tableFields = ['name', 'description'];

  getData(): any {
    return this.messageTypesResponse;
  }
}
